var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-common-search',{attrs:{"from":'store',"value":_vm.params.keyword}}),_c('goodslist-body'),_c('common-store-footer',{attrs:{"store_id":_vm.store_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }